<template>
  <div id="pedido">
    <!-- <div>
    <p id="nome_pedido"></p>
    <p id="extra_pedido">{{item.quantidade}} unid. - R$ {{(item.precoPago).toFixed(2).replace('.',',')}} - {{item.status}}</p>
    </div>
    <div v-for="items in item.produtos" :key="items._id" id="produtos_list_pedido">
      <p v-if="items.qntSolicitada && items.valor">
        {{ items.qntSolicitada }} unid. - {{ items.id_prod.nome }} - R$
        {{ (items.qntSolicitada * items.valor).toFixed(2).replace(".", ",") }} 
      </p>
    </div>-->

    <div id="detalhes_compra" style="width: 30%;">
      <p style="margin-bottom: 20px;">
        <span id="dado_">Resumo da compra</span>
      </p>
      <p>
        Pedido:
        <span id="dado_">{{this.item.codigoVenda.slice(4)}}</span>
      </p>
      <p>
        Realizado:
        <span id="dado_">{{this.data}}</span>
      </p>
      <p>
        Valor total:
        <span id="dado_" v-if="this.item.precoPago">R$ {{this.item.precoPago.toFixed(2).replace('.', ',')}}</span>
      </p>
    </div>

    <div style="width: 1px; background-color: #E4E4E4;" />

    <div id="detalhes_compra" style="align-self: center;">
      <div id="status_compra">
        <span class="material-icons" id="status_icon" v-if="this.status[0]">store_mall_directory</span>
        <span class="material-icons" id="status_icon_none" v-else>store_mall_directory</span>
        <span class="material-icons" id="status_icon" v-if="this.status[1]">payment</span>
        <span class="material-icons" id="status_icon_none" v-else>payment</span>
        <span class="material-icons" id="status_icon" v-if="this.status[2]">access_time</span>
        <span class="material-icons" id="status_icon_none" v-else>access_time</span>
        <span class="material-icons" id="status_icon" v-if="this.status[3]">local_shipping</span>
        <span class="material-icons" id="status_icon_none" v-else>local_shipping</span>
        <span class="material-icons" id="status_icon" v-if="this.status[4]">done</span>
        <span class="material-icons" id="status_icon_none" v-else>done</span>
        <span
          class="material-icons"
          id="status_icon"
          v-if="this.item.status === 'Cancelado'"
        >remove_shopping_cart</span>
      </div>

      <div id="line_status">
        <div id="line_4" v-if="this.status[4]"/>
        <div id="line_3" v-else-if="this.status[3]"/>
        <div id="line_2" v-else-if="this.status[2]"/>
        <div id="line_1" v-else-if="this.status[1]"/>
        <div id="line_0" v-else/>

      </div>
      <div style="margin-top: 40px;">
        <p v-if="item.status === 'Cancelado'" style="text-align: center">
          Status:
          <span id="dado_" style="color: red;">{{this.item.status}}</span>
        </p>
        <p v-else style="text-align: center;">
          Status:
          <span id="dado_" style="color: green;">{{this.item.status}}</span>
        </p>
      </div>
    </div>

    <div style="width: 1px; background-color: #E4E4E4;" />

    <div id="detalhes_compra" style="align-self: center; width: 50%;">
      <carousel
        :perPage="1"
        :paginationEnabled="true"
        paginationColor="#E4E4E4"
        paginationActiveColor="#8d816b"
        :paginationPadding="3"
      >
        <slide v-for="prod in item.produtos" :key="prod._id">
          <div>
            <img
              v-if="prod.id_prod.image && prod.id_prod.image.key"
              :src="`https://api-store.emporiodasmarcas.com.br/files/product/${prod.id_prod.image.key}`"
              style="height: 100px; width: 100px; object-fit:contain;"
            />
            <p>
              <span id="dado_">{{prod.id_prod.nome}}</span>
            </p>
            <p>
              Tamanho:
              <span id="dado_">{{prod.id_prod.tamanho}}</span>
            </p>
            <p>
              Quantidade:
              <span id="dado_">{{prod.qntSolicitada}}</span>
            </p>
            <p>
              Valor unitário:
              <span id="dado_" v-if="prod.valor">R$ {{prod.valor.toFixed(2).replace('.',',')}}</span>
            </p>
          </div>
        </slide>
      </carousel>
    </div>
  </div>
</template>

<script>
export default {
  name: "Pedidos",
  props: ["item"],
  mounted() {
    let data = new Date(this.item.data);
    let mes = data.getMonth() + 1;
    let mes_str = mes.toString();
    if (mes <= 9) {
      mes_str = "0" + mes_str;
    }
    this.data = data.getDate() + "/" + mes_str + "/" + data.getFullYear();
  },
  beforeMount() {
    this.getStatus();
  },
  data() {
    return {
      data: "",
      status: [false, false, false, false, false]
    };
  },
  methods: {
    getStatus() {
      switch (this.item.status) {
        case "Em análise":
          this.status = [false, false, false, false, false];
          break;

        case "Cancelado":
          this.status = [true, true, true, true, true];
          break;

        case "Pagamento Realizado":
          this.status = [true, true, false, false, false];
          break;

        case "Aguardando Pagamento":
          this.status = [true, false, false, false, false];
          break;

        case "Pago":
          this.status = [true, true, false, false, false];
          break;
        case "Aguardando Entregador":
          this.status = [true, true, true, false, false];
          break;
        case "Em Entrega":
          this.status = [true, true, true, true, false];
          break;
        case "Entregue":
          this.status = [true, true, true, true, true];
          break;
        default:
          this.status = [false, false, false, false, false];
          break;
      }
    }
  }
};
</script>

<style>
#pedido {
  margin-left: 10px;
  margin-right: 10px;
  font-size: 14px;
  width: 97%;
  border: 1px solid #eeeeee;
  padding: 20px;
  font-family: "Source Sans Pro", sans-serif;
  margin-top: 10px;
  border-radius: 3px;
  display: inline-flex;
  box-shadow: 2px 2px 4px 0 #eeeeee;
}

#dado_ {
  font-weight: 700;
}

#pedido p {
  text-align: left;
  font-size: 14px;
}

#line_0 {
  background-color: #558b2f;
  height: 4px;
  margin-top: -20px;
  margin-left: 12%;
  margin-right: 10%;
  width: 0%;
  display: block;
}

#line_1 {
  background-color: #558b2f;
  height: 4px;
  margin-top: -20px;
  margin-left: 12%;
  margin-right: 10%;
  width: 20%;
  display: block;
}

#line_2 {
  background-color: #558b2f;
  height: 4px;
  margin-top: -20px;
  margin-left: 12%;
  margin-right: 10%;
  width: 40%;
  display: block;
}

#line_3 {
  background-color: #558b2f;
  height: 4px;
  margin-top: -20px;
  margin-left: 12%;
  margin-right: 10%;
  width: 56%;
  display: block;
}


#line_4 {
  background-color: #558b2f;
  height: 4px;
  margin-top: -20px;
  margin-left: 12%;
  margin-right: 10%;
  width: 77%;
  display: block;
}

#line_status {
  justify-self: center;
}

#nome_pedido {
  font-weight: lighter;
}

#extra_pedido {
  font-weight: bold;
}
.material-icons.md-light {
  color: rgba(255, 255, 255, 1);
}
.material-icons.md-light.md-inactive {
  color: rgba(255, 255, 255, 0.3);
}

#status_icon {
  background-color: white;
  color: #558b2f;
  border: 3px solid #558b2f;
  border-radius: 20px;
  width: 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 40px;
}

#status_icon_none {
  background-color: white;
  color: #aaaaaa;
  border: 3px solid #ffffff;
  border-radius: 20px;
  width: 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 40px;
}

#produtos_list_pedido {
  margin-left: 20px;
  margin-top: 10px;
}

#status_compra {
  padding-left: 10%;
  padding-right: 10%;
  display: flex;
  justify-content: space-between;
}

#detalhes_compra {
  padding: 10px;
}

#detalhes_compra p {
  margin-bottom: 10px;
}

@media screen and (max-width: 800px) {

  #pedido {
  margin-left: 10px;
  margin-right: 10px;
  font-size: 14px;
  width: 97%;
  border: 1px solid #eeeeee;
  padding: 20px;
  font-family: "Source Sans Pro", sans-serif;
  margin-top: 10px;
  border-radius: 3px;
  display: block;
  box-shadow: 2px 2px 4px 0 #eeeeee;
}
}
</style>
